<template>
  <li class="mega-menu outside">
    <a v-if="user"
        class="nav-link"
        :class="{ active: openbonusUI }"
        href="javascript:void(0);"
        @click="openmegamenu"
    >
      <feather type="layers"></feather>
      <span>{{ user.name }}</span>
    </a>
    <div
        class="mega-menu-container nav-submenu menu-to-be-close"
        :class="{ 'd-block': openbonusUI }"
    >
      <div class="container-fluid">
        <div class="row">
          <div
              class="col mega-box"
              v-for="(menuItem, index) in megamenuItems"
              :key="index"
          >
            <div class="mobile-title d-none" v-if="index == 0" style="padding-left: 10px;">
              <h5 v-if="user"><img
                  class="b-r-10 mr-2" style="width: 37px"
                  :src="user.image"
                  alt=""
              /> {{ user.name }}</h5>
              <feather type="x" @click="closeBonusUI"></feather>
            </div>
            <div
                class="link-section"
                :class="[menuItem.design, { active: menuItem.active }]"
            >
              <div>
                <h6 style="cursor: pointer" @click="goTo(menuItem)">
                  <feather
                      class="mr-2"
                      :type="menuItem.icon"
                  ></feather>
                  {{ $t(menuItem.title) }}
                </h6>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'BonusUI',
  data() {
    return {
      openbonusUI: false,
    };
  },
  computed: {
    ...mapState({
      megamenuItems: (state) => state.menu.megamenu,
    }),
    user() {
      return this.$store.getters['shared/getUser']
    }
  },
  methods: {

    logout: async function () {
      await this.$store.dispatch('shared/logout')
      this.$router.push({name: 'Login'}).catch(() => {})
    },

    goTo(selected) {
      if (selected.url == 'logout') {
        this.logout()
      } else {
        this.$router.push({name: selected.url}).catch(() => {})
      }
    },
    openmegamenu() {
      this.openbonusUI = !this.openbonusUI;
    },
    closeBonusUI() {
      this.openbonusUI = false;
    },
    setNavActive(item) {
      this.$store.dispatch('menu/setBonusNavActive', item);
    },
  },
};
</script>
